/**
 * Change History Constants
 *
 * Centralized field label maps for each section. These provide human-readable labels
 * for form field names used in change history entries.
 */

// ============================================================================
// Field Label Maps — human-readable labels for each form field per section
// ============================================================================

/** Overview section field labels */
export const OVERVIEW_FIELD_LABELS: Record<string, string> = {
  program_predecessor: 'Program Predecessor',
  program_complexity: 'Program Complexity',
  product_tier: 'Product Tier',
  product_sub_category: 'Product Subcategory',
  major_call_outs: 'Major Call Outs',
  program_description: 'Program Description',
  program_comments: 'Program Comments',
  compatible_devices: 'Compatible Devices',
  is_confidential: 'Confidential',
};

/** Country & Key Dates section field labels */
export const KEY_DATES_FIELD_LABELS: Record<string, string> = {
  last_pdp_gate_month: 'Last PDP Gate Month',
  last_freshlot_sale_month_qtr: 'Last Freshlot Sale Month/Qtr',
  end_of_software_support: 'End of Software Support',
  end_of_security_upgrades: 'End of Security Upgrades',
  product_announce_pa_date: 'Product Announce (PA) Date',
  end_of_manufacturing: 'End of Manufacturing',
  end_of_life: 'End of Life',
};

/** Manufacturing Info section field labels */
export const MANUFACTURING_FIELD_LABELS: Record<string, string> = {
  partiness: 'Partiness',
  manufacturing_engagement: 'Manufacturing Engagement',
  number_of_manufacturers: 'Number of Manufacturers',
  manufacturer_company: 'Manufacturer Company',
  product_life_in_months: 'Product Life (Months)',
  cost_center_code: 'Cost Center Code',
  project_hw_id: 'Project HW ID',
  hw_program_size: 'HW Program Size',
  manufacturing_info_comments: 'Manufacturing Comments',
};

/** Market Info section field labels */
export const MARKET_FIELD_LABELS: Record<string, string> = {
  global_life_volume_est: 'Global Life Volume Estimate',
  primary_or_expansion_launch: 'Primary/Expansion Launch',
  significance_vol_at_resellers: 'Significant Vol. at Resellers',
  market_info_comments: 'Market Comments',
};

/** Specifications section field labels */
export const SPECIFICATIONS_FIELD_LABELS: Record<string, string> = {
  alexa_enabled: 'Alexa Enabled',
  camera_enabled: 'Camera Enabled',
  os: 'Operating System',
  new_soc: 'New SoC',
  soc_partiness: 'SoC Partiness',
  soc_name: 'SoC Name',
  project_coa: 'Project COA',
  display_enabled: 'Display Enabled',
  mic_enabled: 'Mic Enabled',
  mic_field_range: 'Mic Field Range',
  specifications_comments: 'Specifications Comments',
};

/** Financial Info section field labels (FPN only) */
export const FINANCIAL_FIELD_LABELS: Record<string, string> = {
  us_msrp_usd: 'US MSRP (USD)',
  ww_msrp_usd: 'WW MSRP (USD)',
  ww_asp_usd: 'WW ASP (USD)',
  ww_net_promo_percent: 'WW Net Promo %',
  warranty_offering: 'Warranty Offering',
  remorse_policy: 'Remorse Policy',
  financial_info_comments: 'Financial Info Comments',
};

// ============================================================================
// Change History Export S3 Constants
// ============================================================================

/** S3 bucket prefix for change history exports. Full name: verity-change-history-${stage} */
export const CHANGE_HISTORY_S3_BUCKET_PREFIX = 'verity-change-history';

/** S3 key for the exported change history JSON file */
export const CHANGE_HISTORY_S3_KEY = 'change_history/list_change_history.json';
